import UpdateIOUCost from "../UpdateIOUCost/UpdateIOUCost";

const ViewIOUCost = (props) => {
  return <UpdateIOUCost {...props} viewMode={true} mode="view"/>;
};

export default ViewIOUCost;
